// Main application file
// Responsible for initializing the application

// polyfills
import 'promise-polyfill/src/polyfill'
import 'whatwg-fetch'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import App from './App'
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'
import router from './router'
import auth from './services/auth'
import Vuetify from 'vuetify'
import i18n from './i18n'

Vue.use(Vuetify, {
  iconfont: 'md',
})
// sentry integration
// Raven
//     .config(process.env.SENTRY_DSN, {
//       allowSecretKey: process.env.NODE_ENV === 'development',
//       release: process.env.VERSION
//     })
//     .addPlugin(RavenVue, Vue)
//     .install()

Vue.config.productionTip = false

// global components
import DateComponent from './components/generic/Datetime.vue'
Vue.component('date', DateComponent)

// Auth initialization
auth.checkAuth()

// vuex initialization
import { store, initGlobalState } from './store'

// router configuration
// global hooks to exectute at every url change
router.beforeEach(function (to, from, next) {
  // fetch team and branding information and save it to the global state
  initGlobalState(store)
  // check auth status and redirect to login page if needed
  if (to.meta.auth && !auth.authenticated) {
    next('/login')
  } else {
    next()
  }
})

// initialize the Vue app
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App }
})
